/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Type_PlaceholderInputs */

const en_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Type`)
};

const fr_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de métadonnée`)
};

const de_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatentyp`)
};

const it_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di metadati`)
};

const ru_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип метаданных`)
};

const es_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de metadatos`)
};

const zh_cn2_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据类型`)
};

const ja_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータタイプ`)
};

const hi_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा प्रकार`)
};

const pt_pt2_options_metadata_type_placeholder = /** @type {(inputs: Options_Metadata_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Type" |
*
* @param {Options_Metadata_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_type_placeholder = /** @type {((inputs?: Options_Metadata_Type_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Type_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_type_placeholder(inputs)
	if (locale === "de") return de_options_metadata_type_placeholder(inputs)
	if (locale === "it") return it_options_metadata_type_placeholder(inputs)
	if (locale === "ru") return ru_options_metadata_type_placeholder(inputs)
	if (locale === "es") return es_options_metadata_type_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_type_placeholder(inputs)
	if (locale === "ja") return ja_options_metadata_type_placeholder(inputs)
	if (locale === "hi") return hi_options_metadata_type_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_type_placeholder(inputs)
	return en_options_metadata_type_placeholder(inputs)
});